// extracted by mini-css-extract-plugin
export default {"container":"FilterWarningIcon_container__nkxDz","icon":"FilterWarningIcon_icon__xmlBD"};